/*Generated from the `:::slide{key="49375a14-c586-4ad9-8492-fad88553dc3a" slug="familiar-initials"}` (simplified/001-P1/002/干.mdx), `:::slide{key="1fbe4e17-80eb-47a9-80d2-efe8d7f8c13e" slug="close-initials"}` (simplified/001-P1/002/干.mdx), `:::slide{key="e9b3be77-1d79-4d1d-95ae-18a89a14fea9" slug="hard-initials"}` (simplified/001-P1/002/干.mdx), `:::slide{key="7c3ac1c4-17e5-4f99-a7ea-ae1eaebb8339" slug="subtle-initials"}` (simplified/001-P1/002/干.mdx) directives, merged because they share one anchor. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, Span, TBody, TD, TR, Table, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!Span) _missingMdxReference("Span", true);
  if (!TBody) _missingMdxReference("TBody", true);
  if (!TD) _missingMdxReference("TD", true);
  if (!TR) _missingMdxReference("TR", true);
  if (!Table) _missingMdxReference("Table", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.blockquote) _missingMdxReference("html.blockquote", true);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  if (!html.table) _missingMdxReference("html.table", true);
  if (!html.tbody) _missingMdxReference("html.tbody", true);
  if (!html.td) _missingMdxReference("html.td", true);
  if (!html.th) _missingMdxReference("html.th", true);
  if (!html.thead) _missingMdxReference("html.thead", true);
  if (!html.tr) _missingMdxReference("html.tr", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      keepWithNext: "true",
      count: "10",
      children: _jsx(html.p, {
        children: "Many initials are very close to familiar English sounds:",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "Table",
      count: "10",
      children: _jsx(Table, {
        children: _jsxs(TBody, {
          children: [_jsxs(TR, {
            children: [_jsxs(TD, {
              children: [_jsx(Span, {
                className: "italic",
                children: "p-",
                components: html
              }), " (", _jsx(Span, {
                className: "font-bold",
                children: "p",
                components: html
              }), "un)"]
            }), _jsxs(TD, {
              children: [_jsx(Span, {
                className: "italic",
                children: "m-",
                components: html
              }), " (", _jsx(Span, {
                className: "font-bold",
                children: "m",
                components: html
              }), "ud)"]
            })]
          }), _jsxs(TR, {
            children: [_jsxs(TD, {
              children: [_jsx(Span, {
                className: "italic",
                children: "f-",
                components: html
              }), " (", _jsx(Span, {
                className: "font-bold",
                children: "f",
                components: html
              }), "un)"]
            }), _jsxs(TD, {
              children: [_jsx(Span, {
                className: "italic",
                children: "t-",
                components: html
              }), " (", _jsx(Span, {
                className: "font-bold",
                children: "t",
                components: html
              }), "uck)"]
            })]
          }), _jsxs(TR, {
            children: [_jsxs(TD, {
              children: [_jsx(Span, {
                className: "italic",
                children: "n-",
                components: html
              }), " (", _jsx(Span, {
                className: "font-bold",
                children: "n",
                components: html
              }), "ut)"]
            }), _jsxs(TD, {
              children: [_jsx(Span, {
                className: "italic",
                children: "l-",
                components: html
              }), " (", _jsx(Span, {
                className: "font-bold",
                children: "l",
                components: html
              }), "uck)"]
            })]
          }), _jsxs(TR, {
            children: [_jsxs(TD, {
              children: [_jsx(Span, {
                className: "italic",
                children: "k-",
                components: html
              }), " (", _jsx(Span, {
                className: "font-bold",
                children: "k",
                components: html
              }), "ungfu)"]
            }), _jsxs(TD, {
              children: [_jsx(Span, {
                className: "italic",
                children: "s-",
                components: html
              }), " (", _jsx(Span, {
                className: "font-bold",
                children: "s",
                components: html
              }), "un)"]
            })]
          })]
        }),
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "1",
      kind: "p",
      keepWithNext: "true",
      count: "10",
      children: _jsx(html.p, {
        children: "A few other initials also have close English approximations:",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "1",
      kind: "table",
      count: "10",
      children: _jsxs(html.table, {
        children: [_jsx(html.thead, {
          children: _jsxs(html.tr, {
            children: [_jsx(html.th, {
              children: "Initial",
              components: html
            }), _jsx(html.th, {
              children: "English example",
              components: html
            })]
          }),
          components: html
        }), _jsxs(html.tbody, {
          children: [_jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "b-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: [_jsx(html.strong, {
                children: "b",
                components: html
              }), "uck"]
            })]
          }), _jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "d-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: [_jsx(html.strong, {
                children: "d",
                components: html
              }), "uck"]
            })]
          }), _jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "g-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: [_jsx(html.strong, {
                children: "g",
                components: html
              }), "un"]
            })]
          }), _jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "h-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: [_jsx(html.strong, {
                children: "h",
                components: html
              }), "ut"]
            })]
          }), _jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "r-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: [_jsx(html.strong, {
                children: "r",
                components: html
              }), "un"]
            })]
          })]
        })]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "4",
      section: "1",
      kind: "blockquote",
      count: "10",
      children: _jsx(html.blockquote, {
        children: _jsxs(html.p, {
          children: ["For now, ", _jsx(html.em, {
            children: "g-",
            components: html
          }), " as in ", _jsx(html.strong, {
            children: "g",
            components: html
          }), "un is a good approximation to remember. We'll cover the nuanced phonetic differences in a later lesson."]
        }),
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "5",
      section: "2",
      kind: "p",
      keepWithNext: "true",
      count: "10",
      children: _jsx(html.p, {
        children: "Some aren't as straightforward:",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "6",
      section: "2",
      kind: "table",
      count: "10",
      children: _jsxs(html.table, {
        children: [_jsx(html.thead, {
          children: _jsxs(html.tr, {
            children: [_jsx(html.th, {
              children: "Initial",
              components: html
            }), _jsx(html.th, {
              children: "Approximation",
              components: html
            })]
          }),
          components: html
        }), _jsxs(html.tbody, {
          children: [_jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "z-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: ["≈ \"ds\" in ki", _jsx(html.strong, {
                children: "ds",
                components: html
              })]
            })]
          }), _jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "c-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: ["≈ \"ts\" in ki", _jsx(html.strong, {
                children: "ts",
                components: html
              })]
            })]
          })]
        })]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "7",
      section: "3",
      kind: "p",
      keepWithNext: "true",
      count: "10",
      children: _jsx(html.p, {
        children: "And some have subtle differences based on tongue position:",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "8",
      section: "3",
      kind: "table",
      count: "10",
      children: _jsxs(html.table, {
        children: [_jsx(html.thead, {
          children: _jsxs(html.tr, {
            children: [_jsx(html.th, {
              children: "👅 Down",
              components: html
            }), _jsx(html.th, {
              children: "👅 Up",
              components: html
            }), _jsx(html.th, {
              children: "Approximation",
              components: html
            })]
          }),
          components: html
        }), _jsxs(html.tbody, {
          children: [_jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "j-",
                components: html
              }),
              components: html
            }), _jsx(html.td, {
              children: _jsx(html.em, {
                children: "zh-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: ["\"j\" in ", _jsx(html.strong, {
                children: "j",
                components: html
              }), "udge"]
            })]
          }), _jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "q-",
                components: html
              }),
              components: html
            }), _jsx(html.td, {
              children: _jsx(html.em, {
                children: "ch-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: ["\"ch\" in ", _jsx(html.strong, {
                children: "ch",
                components: html
              }), "urch"]
            })]
          }), _jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "x-",
                components: html
              }),
              components: html
            }), _jsx(html.td, {
              children: _jsx(html.em, {
                children: "sh-",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: ["\"sh\" in ", _jsx(html.strong, {
                children: "sh",
                components: html
              }), "irt"]
            })]
          })]
        })]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "9",
      section: "3",
      kind: "p",
      count: "10",
      children: _jsx(html.p, {
        children: "You don't need to remember all of this now; we'll slowly introduce them in future lessons.",
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
